export const localizedRoutesMap: Record<string, Record<string, string>> = {
  en: {
    home: '/en',
    services: '/en/services',
    webDesign: '/en/web-design',
    websiteDevelopment: '/en/website-development',
    businessWebsites: '/en/business-websites',
    ecommerce: '/en/ecommerce',
    seo: '/en/seo',
    localSeo: '/en/local-seo',
    softwareDevelopment: '/en/software-development',
    branding: '/en/branding',
    aiSolutions: '/en/ai-solutions',
    webApplications: '/en/web-applications',
    about: '/en/about',
    work: '/en/work',
    contact: '/en/contact',
    templates: '/en/templates',
    pricing: '/en/pricing',
    articles: '/en/articles/:title',
    blog: '/en/blog',
    payment: '/en/payment',
    privacy: '/en/privacy',
    terms: '/en/terms',
    refund: '/en/refund',
    profile: '/en/profile',
    admin: '/en/admin',
    publish: '/en/publish',
    success: '/en/success',
    cancel: '/en/cancel',
  },
  sq: {
    home: '/',
    services: '/sq/sherbimet',
    webDesign: '/sq/web-dizajn',
    websiteDevelopment: '/sq/ndertim-uebfaqesh',
    businessWebsites: '/sq/webfaqe-per-biznese',
    ecommerce: '/sq/online-shop',
    seo: '/sq/seo',
    localSeo: '/sq/seo-lokal',
    softwareDevelopment: '/sq/zhvillim-softueri',
    branding: '/sq/branding',
    aiSolutions: '/sq/ai-zgjidhje',
    webApplications: '/sq/aplikacione-web',
    about: '/sq/rreth-nesh',
    work: '/sq/puna',
    contact: '/sq/kontakt',
    templates: '/sq/shabllone',
    pricing: '/sq/cmimet',
    articles: '/sq/artikujt/:title',
    blog: '/sq/blog',
    payment: '/sq/pagesa',
    privacy: '/sq/privatesia',
    terms: '/sq/kushtet',
    refund: '/sq/rimbursim',
    profile: '/sq/profili',
    admin: '/sq/admin',
    publish: '/sq/publiko',
    success: '/sq/sukses',
    cancel: '/sq/anulo',
  },
  de: {
    home: '/de',
    services: '/de/dienstleistungen',
    webDesign: '/de/webdesign',
    websiteDevelopment: '/de/webentwicklung',
    businessWebsites: '/de/business-websites',
    ecommerce: '/de/e-commerce',
    seo: '/de/seo',
    localSeo: '/de/local-seo',
    softwareDevelopment: '/de/softwareentwicklung',
    branding: '/de/branding',
    aiSolutions: '/de/ki-loesungen',
    webApplications: '/de/web-app-entwicklung',
    about: '/de/ueber-uns',
    work: '/de/arbeit',
    contact: '/de/kontakt',
    templates: '/de/vorlagen',
    pricing: '/de/preise',
    articles: '/de/artikel/:title',
    blog: '/de/blog',
    payment: '/de/zahlung',
    privacy: '/de/datenschutz',
    terms: '/de/bedingungen',
    refund: '/de/rueckerstattung',
    profile: '/de/profil',
    admin: '/de/admin',
    publish: '/de/veroeffentlichen',
    success: '/de/erfolg',
    cancel: '/de/stornieren',
  },
};
